require('angular').module('wowApp.shop')
    .service('LoginService', ['$rootScope', '$q', 'Restangular', 'GlobalHeaderPanelService', 'ShopperService', '$state', '$stateParams', 'ShopPageStateService', 'SettingsService', 'AtmService', 'CurrentUserService', 'AgeCalculatorService', require('./../login-service')])
    .service('PersistentLoginService', ['Restangular', require('./persistent-login-service')])
    .directive('bwsPersistentLogin', ['$q', 'LoginService', 'BreakpointsService', '$state', '$window', 'MoveFocus', 'olyFormValidationSummaryService', 'GoogleCaptchaV3Service', require('./persistent-login-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/persistent-login/index.js
 **/